import { render, staticRenderFns } from "./ShoulderItem.vue?vue&type=template&id=df3046fc&scoped=true&"
import script from "./ShoulderItem.vue?vue&type=script&lang=js&"
export * from "./ShoulderItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoulderItem.vue?vue&type=style&index=0&id=df3046fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3046fc",
  null
  
)

export default component.exports